import React, { useEffect, useState } from 'react';
import { Avatar, List, Modal } from 'antd';
import cx from 'classnames';
import { DEFAULT_AVATAR } from '@gtintel/platform-constants';
import { useStores } from '@gtintel/platform-stores';
import { ProposalStatus } from '@gtintel/platform-types';
import TagSection from './components/TagSection';
import styles from './partnerCard.module.scss';
const {
  confirm
} = Modal;
const PartnerCard = props => {
  const {
    partnerStore
  } = useStores();
  const {
    partner,
    project,
    onClickName
  } = props;
  const [partnerStatus, setPartnerStatus] = useState('');
  const [buttonLength, setButtonLength] = useState(partner.buttonSelect);
  const confirmationModal = props => {
    const {
      partner,
      project,
      selectPartner,
      unMatchPartner
    } = props;
    const words = partnerStatus === ProposalStatus.PENDING ? ['unmatch', 'from'] : ['match', 'to'];
    confirm({
      title: `Are you sure you want to ${words[0]} ${partner.title} ${words[1]} this project?`,
      content: 'This action can be reverted in the project overview page.',
      okText: partnerStatus === ProposalStatus.PENDING ? `UNMATCH PARTNER` : `MATCH PARTNER`,
      cancelText: 'CANCEL',
      onOk: () => {
        if (partnerStatus === ProposalStatus.PENDING) {
          unMatchPartner(partner.id, project?.id, project);
          setPartnerStatus('');
          setButtonLength('SELECT');
        } else {
          selectPartner(partner, project);
          setPartnerStatus('Pending');
          setButtonLength('');
        }
      }
    });
  };
  if (partnerStatus !== partner.status) {
    setPartnerStatus(partner.status);
  }
  useEffect(() => {
    if (partner.status === 'Pending' || partnerStatus === 'Pending') {
      setPartnerStatus('Pending');
    }
  }, [partnerStatus, partner]);
  useEffect(() => {
    setButtonLength(partner.buttonSelect);
  }, [partner]);
  return <List.Item data-testid="partner-list-container" className={cx(styles.container, 'admin-partner-card')}>
      <List.Item.Meta avatar={<Avatar src={partner.avatar ?? DEFAULT_AVATAR} />} title={<div>
            <div>
              <div className={styles.username} onClick={() => {
          partnerStore.setSelectedPartner(partner);
          onClickName && onClickName();
        }}>
                <span>{partner.title}</span>
              </div>
              <div className={styles.tagSection}>
                <TagSection tags={partner.tags} project={project} />
              </div>
            </div>
            <div className={styles.floatSection}>
              {(!!buttonLength.length || partnerStatus === ProposalStatus.PENDING) && <b className={cx('select', {
          [styles.unselect]: partnerStatus === ProposalStatus.PENDING
        })} onClick={() => {
          confirmationModal(props);
        }}>
                  {partnerStatus === ProposalStatus.PENDING ? 'UNSELECT' : 'SELECT'}
                </b>}
            </div>
            <b className={cx('declined', styles.status)}>{partnerStatus}</b>
          </div>} description={partner.street_address} />
      {partnerStatus !== ProposalStatus.PENDING && <b className={cx('declined', styles.status)}>{partner.status}</b>}
    </List.Item>;
};
export default PartnerCard;